<script setup lang="ts">
// "К коту возвращаются" — the numbers, then what people say, as their own notes on
// cream paper (the user's voice is cream in the chat), each stuck on a little askew.
import ScrollReveal from '@/components/ui/animation/ScrollReveal.vue'

const cards = [
  { q: '«Пишу коту каждый вечер. Уходила на 3 месяца — вернулась, а он всё помнит.»', a: 'Аня, 21', tilt: -1.2 },
  { q: '«Спрашиваю про него каждое утро. Спокойнее, чем гадать самой в три ночи.»', a: 'Лера, 19', tilt: 0.8 },
  { q: '«Не обещает сказку. Один раз честно сказал отпустить — и был прав.»', a: 'Соня, 24', tilt: -0.6 },
];

const stats: [string, string][] = [
  ['2 000+', 'человек с котом'],
  ['21 000', 'раскладов сделано'],
  ['24/7', 'кот на связи'],
];
</script>

<template>
  <section
    id="proof"
    class="scroll-mt-20 py-16 md:py-24"
  >
    <div class="site-container">
      <ScrollReveal class="mb-4 text-center">
        <div class="type-overline mb-3.5 text-primary-ink">Нам доверяют</div>
        <h2 class="type-display">К коту возвращаются</h2>
      </ScrollReveal>

      <ScrollReveal
        class="mb-12 flex flex-wrap items-center justify-center gap-x-10 gap-y-6"
      >
        <template
          v-for="([n, l], i) in stats"
          :key="i"
        >
          <div
            v-if="i > 0"
            class="proof-rule hidden h-11 sm:block"
          />
          <div class="text-center">
            <div class="font-serif text-4xl tabular-nums text-foreground">{{ n }}</div>
            <div class="type-caption mt-1">{{ l }}</div>
          </div>
        </template>
      </ScrollReveal>

      <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
        <ScrollReveal
          v-for="(c, i) in cards"
          :key="i"
          :delay="(i + 1) * 80"
        >
          <figure
            class="proof-note paper-tag relative h-full px-7 pb-6 pt-8"
            :style="{ '--tilt': `${c.tilt}deg` }"
          >
            <span
              class="proof-tape"
              aria-hidden="true"
            />
            <div
              class="font-serif text-3xl leading-[0.5] opacity-60"
              aria-hidden="true"
            >“</div>
            <blockquote class="mt-3.5 text-[16.5px] leading-relaxed">{{ c.q }}</blockquote>
            <figcaption class="mt-[18px] text-sm font-semibold opacity-75">{{ c.a }}</figcaption>
          </figure>
        </ScrollReveal>
      </div>
    </div>
  </section>
</template>

<style scoped>
.proof-rule {
  border-left: 1.5px dashed color-mix(in srgb, var(--foreground) 22%, transparent);
}
/* A note on cream paper, taped onto the page. */
.proof-note {
  border-radius: var(--paper-radius-sm);
  transform: rotate(var(--tilt));
  box-shadow: inset 0 1px 0 rgb(255 255 255 / 0.55), 0 10px 18px -8px var(--paper-shade);
}
.proof-tape {
  position: absolute;
  top: -9px;
  left: 50%;
  width: 70px;
  height: 20px;
  transform: translateX(-50%) rotate(3deg);
  background: color-mix(in srgb, var(--paper-stock) 60%, var(--primary-ink));
  opacity: 0.85;
  clip-path: var(--paper-cut-tape);
}
</style>
